function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.40731 3.77816C10.1922 3.27305 10.1983 2.06746 9.42108 1.08541C8.64384 0.103361 7.37753 -0.283272 6.59269 0.221841C5.80785 0.726955 5.80168 1.93254 6.57892 2.91459C7.35616 3.89664 8.62247 4.28327 9.40731 3.77816Z",
  fill: "#121212"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7338 11.3526C12.284 10.539 11.9539 9.27379 10.9963 8.52677C10.0388 7.77974 8.81647 7.83375 8.26622 8.6474C7.71597 9.46104 8.04614 10.7262 9.00368 11.4732C9.96123 12.2203 11.1835 12.1662 11.7338 11.3526Z",
  fill: "#121212"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5789 5.08541C13.8017 6.06746 13.8078 7.27305 14.5927 7.77816C15.3775 8.28327 16.6438 7.89664 17.4211 6.91459C18.1983 5.93254 18.1922 4.72695 17.4073 4.22184C16.6225 3.71673 15.3562 4.10336 14.5789 5.08541Z",
  fill: "#121212"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 11C0.89543 11 0 11.8954 0 13V21H22V13C22 11.8954 21.1046 11 20 11H17.7808C16.8547 11 16.1448 11.614 15.8179 12.2904C15.3693 13.2189 14.1396 15 11 15C7.86039 15 6.63068 13.2189 6.18208 12.2904C5.85523 11.614 5.14526 11 4.21922 11H2ZM2 19V13H4.21925C4.21925 13 4.22277 13 4.22997 13.0024C4.23796 13.0051 4.25184 13.0112 4.26998 13.0241C4.30878 13.0515 4.35156 13.0991 4.38128 13.1606C5.04685 14.538 6.85681 17 11 17C15.1432 17 16.9531 14.538 17.6187 13.1606C17.6484 13.0991 17.6912 13.0515 17.73 13.0241C17.7482 13.0112 17.762 13.0051 17.77 13.0024C17.7772 13 17.7808 13 17.7808 13H20V19H2Z",
  fill: "#121212"
});

function SvgPlanting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanting);
export default __webpack_public_path__ + "static/media/Planting.6660ef6c.svg";
export { ForwardRef as ReactComponent };